import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {ModalExtended} from 'ngx-dynamic-modal';
import {CampaignPrefixConfigService} from '../../services/campaign-prefix-config.service';

@Component({
  selector: 'app-campaign-prefix-config-edit',
  templateUrl: './campaign-prefix-config-edit.component.html',
  styleUrls: ['./campaign-prefix-config-edit.component.scss']
})
export class CampaignPrefixConfigEditComponent extends ModalExtended implements OnInit {

  formData: FormGroup;
  data: Object;
  loading: boolean = false;
  submitted: boolean = false;

  errors: Object = {};

  constructor(private fb: FormBuilder, private campPrefix: CampaignPrefixConfigService, private alertService: AlertaService) {
    super();
    this.formData = this.fb.group({
      'active': new FormControl('1'),
      'prefix': new FormControl('', Validators.required),
      'provider' : new FormControl('', Validators.required),
      'orden': new FormControl('1', Validators.required)
    });
  }

  onExit(): void {
    this.applyCallback(true);
    this.close();
  }

  savePrefixConfig(): void {

    this.errors = {};
    if(!this.formData.valid){
      this.submitted = true;
      return;
    }

    this.loading = true;

    this.campPrefix.postPrefixConfig(this.data['camp'].pkCamp, this.formData.value).subscribe(
      (result) => {
        (result.hasOwnProperty('errors'))
          ? this.errors = result.errors
          : this.alertService.addAlert('success', 'Prefix config have been created successfully')
        ;

        this.loading = false;
      }
    )
  }

  updatePrefixConfig(): void {

    this.errors = {};
    if(!this.formData.valid){
      this.submitted = true;
      return;
    }

    this.loading = true;

    this.campPrefix.putPrefixConfig(this.data['camp'].pkCamp, this.data['element']['pk'], this.formData.value).subscribe(
      (result) => {
        (result.hasOwnProperty('errors'))
          ? this.errors = result.errors
          : this.alertService.addAlert('success', 'PABX config have been updated successfully')
        ;
        this.loading = false;
      }
    )
  }

  ngOnInit(): void {
    if(this.data.hasOwnProperty('element')){
      this.formData.controls['active'].setValue(this.data['element']['active']);
      this.formData.controls['prefix'].setValue(this.data['element']['prefix']);
      this.formData.controls['provider'].setValue(this.data['element']['provider']);
      this.formData.controls['orden'].setValue(this.data['element']['orden']);

    }
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/campaign-prefix-config-edit/campaign-prefix-config-edit.component.ts